import React from 'react';
import './checkbox.less';
import { Checkbox as AntdCheckbox } from 'antd';

const Checkbox = (props) => {
  return (
    <div className="checkbox">
      <AntdCheckbox {...props}>{props.text ? props.text : false}</AntdCheckbox>
    </div>
  );
};

export default Checkbox;
